import { CourseAccessTypeEnum } from '../types/course'

export const courseAccessLocaleKeys = {
  [CourseAccessTypeEnum.fullAccess]:
    'entity_settings.course.access_type.full_access',
  [CourseAccessTypeEnum.drippingContent]:
    'entity_settings.course.access_type.drip_content',
}
